<template>
  <div class="h-toolbarBg">
    <ejs-toolbar>
      <e-items>
        <e-item v-if='addBtn' prefixIcon='icon hero-icon hero-icon-add' :tooltipText='$t("Security.add")' :click='notices' eventType='add'></e-item>
        <e-item v-if='editBtn' prefixIcon='icon hero-icon hero-icon-edit' :tooltipText='$t("Security.modify")' :click='notices' eventType='edit'></e-item>
        <e-item v-if='delBtn' prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("Security.delete")' :click='notices' eventType='del'></e-item>
        <e-item v-if='refreshBtn' prefixIcon='icon hero-icon hero-icon-refresh' :tooltipText='$t("Common.refresh")' :click='notices' eventType='refresh'></e-item>
      </e-items>
    </ejs-toolbar>
    <div v-if='keywordsInput' class='h-inputBox'>
      <ejs-textbox v-model='keyword' :placeholder='$t("Security.inputRoleName")' @change='keydownFunc'></ejs-textbox>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToolBar',
  props:{
    addBtn: { type: Boolean, default: false },
    delBtn: { type: Boolean, default: false },
    editBtn: { type: Boolean, default: false },
    refreshBtn: { type: Boolean, default: false },
    keywordsInput: { type: Boolean, default: false }
  },
  data(){
    return {
      keyword: '',
    }
  },
  methods: {
    notices(args) {
      if (args.item.eventType === 'refresh') {
        this.keyword = '';
        this.$emit('keyword',this.keyword);
      }
      this.$emit('notice', args.item.eventType);
    },
    keydownFunc() {
      this.$emit('keyword',this.keyword);
      this.$emit('notice','query');
    }
  }
}
</script>
